export const TRACE_ID_STORAGE_KEY = 'app-space:user:traceId'
